import { FormControlLabel, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const Container = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: 8,
  padding: 30,
  // border: '1px solid #2d343e',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  background: theme.palette.type === 'dark' ? '#0b0f14' : COLORS.WHITE,
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 10,
  },
}));

export const PlansContainer = styled('div')(({ theme }) => ({
  marginTop: 20,
  display: 'flex',
  gap: 20,
  height: 'auto',
  [theme.breakpoints.down(1700)]: {
    flexDirection: 'column',
  },
}));

export const CustomFormControl = styled(FormControlLabel)({
  margin: '0 -7px 0 5px',
});

export const CustomText = styled(Typography)(({ theme, size }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));
